import { api, get, post, del } from './client.js';

const patch = (path, body) => api('PATCH', path, { body });

/**
 * 禁撥名單 API client。
 * Backend mount: /api/ivr/admin/tenants/:hostId/blacklist
 *
 * ⚠️ 權限（上傳取代／批次刪除／清空限母帳號）目前**只有前端 gating** ——
 *    後端這組路由用 RELAY_SHARED_SECRET 認證，請求裡沒有任何使用者身分，擋不了。
 *    這是已知限制，不是遺漏（backend `routes/blacklist.js` 的檔頭有完整說明）。
 */
const base = (hostId) => `/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/blacklist`;

export const blacklistApi = {
    list: (hostId, { limit = 50, cursor } = {}) => {
        const qs = new URLSearchParams({ limit: String(limit) });
        if (cursor) qs.set('cursor', cursor);
        return get(`${base(hostId)}?${qs}`);
    },
    /** q 支援：完整號碼 / 數字前綴 / `*末碼` */
    search: (hostId, q, { limit = 50 } = {}) =>
        get(`${base(hostId)}/search?q=${encodeURIComponent(q)}&limit=${limit}`),
    lookup: (hostId, phone) => get(`${base(hostId)}/lookup?phone=${encodeURIComponent(phone)}`),
    count: (hostId) => get(`${base(hostId)}/count`),
    /** 懷疑筆數不準時的校正出口（掃描，非熱路徑） */
    recount: (hostId) => post(`${base(hostId)}/recount`, {}),
    deletions: (hostId, { limit = 100 } = {}) => get(`${base(hostId)}/deletions?limit=${limit}`),

    add: (hostId, { phone, note }) => post(base(hostId), { phone, note }),
    updateNote: (hostId, phone, note) => patch(`${base(hostId)}/${encodeURIComponent(phone)}`, { note }),
    remove: (hostId, phone) => del(`${base(hostId)}/${encodeURIComponent(phone)}`),
    bulkDelete: (hostId, phones) => post(`${base(hostId)}/bulk-delete`, { phones }),

    /** dryRun=true → 只回差異預覽，不寫任何一筆 */
    import: (hostId, rows, { sourceFile, dryRun } = {}) =>
        post(`${base(hostId)}/import`, { rows, sourceFile, dryRun: !!dryRun }),
    clear: (hostId) => post(`${base(hostId)}/clear`, {}),
};
